import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { eventDispatch } from '../../helpers/Events';
import { getIntegrationsURLPath } from '../../helpers/Integrations';

const IntegrationsButton = ({
  integration,
  disconnecting,
  handleDisconnect,
}) => {
  const intl = useIntl();

  if (integration.website_link_text && !integration.website_url) {
    return null;
  }

  return (
    <>
      {integration.website_url ? (
        <Button
          tag="a"
          target="_blank"
          href={integration.website_url}
        >
          {integration.website_link_text}
        </Button>
      ) : (
        <>
          {integration.is_connected ? (
            <>
              {integration.internal_connect ? (
                <Button
                  tag={Link}
                  to={`${getIntegrationsURLPath()}/${integration.id}`}
                >
                  {intl.formatMessage({ defaultMessage: 'Settings' })}
                </Button>
              ) : (
                <Button
                  color="primary"
                  disabled={disconnecting}
                  onClick={() => {
                    handleDisconnect(integration.id);
                  }}
                >
                  {disconnecting ? (
                    intl.formatMessage({ defaultMessage: 'Disconnecting...' })
                  ) : (
                    intl.formatMessage({ defaultMessage: 'Disconnect' })
                  )}
                </Button>
              )}
            </>
          ) : (
            <>
              {integration.internal_connect ? (
                <Button
                  tag={Link}
                  to={`${getIntegrationsURLPath()}/${integration.id}`}
                >
                  {intl.formatMessage({ defaultMessage: 'Connect' })}
                </Button>
              ) : (
                <Button
                  tag="a"
                  href={integration.authentication_url || '#connect'}
                  onClick={(e) => {
                    if (integration.type === 'importer') {
                      e.preventDefault();
                      eventDispatch('openImportModal', integration.id);
                    }
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Connect' })}
                </Button>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

IntegrationsButton.propTypes = {
  integration: PropTypes.object.isRequired,
  disconnecting: PropTypes.bool.isRequired,
  handleDisconnect: PropTypes.func.isRequired,
};

export default IntegrationsButton;
